import { normalizeFlag } from '@/utils/flags';

const FLAG_DELIMITER = '-';

export default class KbygParams {
  public groupCk?: string;
  public groupId?: string;
  public classId?: string;
  public classPlanId?: string;
  public showEye360?: string;
  public packageId?: string;
  public clientId?: string;
  public flags: string[];

  constructor(data: any) {
    this.groupCk = data.groupCk;
    this.groupId = data.groupId;
    this.classId = data.classId;
    this.classPlanId = data.classPlanId;
    this.showEye360 = data.showEye360;
    this.packageId = data.packageId;
    this.clientId = data.clientId;
    this.flags = KbygParams.parseFlags(data.flag);
  }

  private static parseFlags(flag: any): string[] {
    if (typeof flag !== 'string' || !flag.trim()) {
      return [];
    }

    return flag.split(FLAG_DELIMITER).map(normalizeFlag);
  }

  static of(data: any): KbygParams {
    return new KbygParams(data);
  }
}
